import React, { useEffect, useState, useRef } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cDatePicker,
  I2cTooltip,
  I2cTextarea,
  I2cPhoneField,
  I2cIcon,
  I2cFileUpload,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import {
  programFeatures,
  paymentDueDate,
  cardAccountStatement,
  statementGeneratedOn,
  creditBreue,
  cardholderNotification,
  customerSupportChannels,
  customerSupportProvider,
} from "./FieldsListingLabels";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";

const PaymentCard = ({ control, handleValueChanges, methods, errors }) => {
  const checkboxRef = useRef(null);
  const [selectedCardNotification, setCardNotification] = useState([]);
  const [selectedCustomerSupport, setCustomerSupport] = useState(null);
  const [selectedLatePenalty, setLatePenalty] = useState(null);
  const [selectedGracePeriod, setLateGracePeriod] = useState(null);
  const [selectedStatementGeneration, setSattementGeneration] = useState(null);
  const [selectedCreditCardCollection, setCreditCardCollection] =
    useState(null);
  const [selectedCreditBereau, setCreditBereau] = useState(null);

  // function to handle the checbox group of applicable program features
  const handleApplicableFeatureChanges = (event) => {
    let selectedOptions;
    if (isNaN(event)) selectedOptions = event?.target?.value;
    else selectedOptions = event;
    let updatedSelectedOptions = [
      ...(methods.getValues("pf_card_account_statement") ?? []),
    ];
    if (updatedSelectedOptions.includes(selectedOptions)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== selectedOptions,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(selectedOptions);
    }
    methods.setValue("pf_card_account_statement", updatedSelectedOptions);
    methods.trigger();
    handleValueChanges();
  };
  const handleBureauChanges = (event) => {
    let selectedOptions;
    if (isNaN(event)) selectedOptions = event?.target?.value;
    else selectedOptions = event;
    let updatedSelectedOptions = [
      ...(methods.getValues("pf_credit_reporting_bureaus") ?? []),
    ];
    if (updatedSelectedOptions.includes(selectedOptions)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== selectedOptions,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(selectedOptions);
    }
    if (!updatedSelectedOptions.includes(3)) {
      methods.setValue("pf_credit_reporting_bureaus_other", "");
    }
    methods.setValue("pf_credit_reporting_bureaus", updatedSelectedOptions);
    methods.trigger();
    handleValueChanges();
  };
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">Payment Due Date</div>
            <div className="custom-label-light mb-16">
              Please confirm your Due Date policy.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_payment_due_date_policy"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_payment_due_date_policy")}
                    {...field}
                    name="pf_payment_due_date_policy"
                    onI2cChange={(e) => {
                      if (e.target.value === "no-of-days") {
                        methods.setValue(
                          "pf_payment_due_date_policy_fixed_date",
                          "",
                        );
                      } else {
                        methods.setValue(
                          "pf_payment_due_date_policy_no_of_days",
                          "",
                        );
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {paymentDueDate.map((type, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          className="cardlist-custom-direction"
                          variant="receipt"
                          label={type.label}
                          sublabel=" "
                          type="checkbox"
                          checked={
                            methods.watch("pf_payment_due_date_policy") ===
                            type.value
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            name="of_fisco"
                            filled
                            value={type.value}
                            label=""
                          ></I2cRadio>
                          {type.tooltip !== "" && (
                            <I2cTooltip
                              slot="suffix"
                              hoist
                              content={type.tooltip}
                              placement="right-start"
                            >
                              <I2cIcon name="cs-linear-help-circle"></I2cIcon>
                            </I2cTooltip>
                          )}
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("pf_payment_due_date_policy") === "fixed-date" && (
            <div i2c-grid="6@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pf_payment_due_date_policy_fixed_date"
                  control={control}
                  render={({ field }) => (
                    <>
                      <I2cDatePicker
                        {...field}
                        name="pf_payment_due_date_policy_fixed_date"
                        placeholder="Expiry Date"
                        size="large"
                        I2cDatePicker
                        enableTime
                        label="Specify the due date."
                        dateFormat="d-m-Y"
                        onI2cDateApply={(e) => {
                          if (e.target?.appliedDate)
                            field.onChange(
                              e.target?.appliedDate[0]?.toDateString() ?? "",
                            );
                          else field.onChange("");
                          handleValueChanges();
                        }}
                        defaultDate={
                          methods.watch("pf_payment_due_date_policy_fixed_date")
                            ? new Date(
                                methods.watch(
                                  "pf_payment_due_date_policy_fixed_date",
                                ),
                              )
                            : ""
                        }
                      ></I2cDatePicker>
                      <span slot="label"></span>
                    </>
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pf_payment_due_date_policy_fixed_date &&
                    methods.formState.touchedFields
                      .pf_payment_due_date_policy_fixed_date
                      ? true
                      : false
                  }
                  message={
                    errors.pf_payment_due_date_policy_fixed_date?.message ??
                    "Invalid input"
                  }
                />
              </div>
            </div>
          )}
          {methods.watch("pf_payment_due_date_policy") === "no-of-days" && (
            <div i2c-grid="6@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pf_payment_due_date_policy_no_of_days"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className={"single-input-field"}
                      placeholder="Enter days"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      invalid={
                        errors.pf_payment_due_date_policy_no_of_days
                          ? true
                          : false
                      }
                      required
                      size="large"
                      label="Specify the number of days."
                      name={"pf_payment_due_date_policy_no_of_days"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pf_payment_due_date_policy_no_of_days &&
                    methods.formState.touchedFields
                      .pf_payment_due_date_policy_no_of_days
                      ? true
                      : false
                  }
                  message={
                    errors.pf_payment_due_date_policy_no_of_days?.message ??
                    "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-16">Late Payment Penalty</div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_late_payment_penalty"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Do you wish to define a late payment fee?"
                    value={methods.watch("pf_late_payment_penalty")}
                    {...field}
                    name="pf_late_payment_penalty"
                    onI2cChange={(e) => {
                      if (e.target.value === "no") {
                        methods.setValue("pf_late_payment_fee", "");
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No"].map((type, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("pf_late_payment_penalty") ===
                          type.toLocaleLowerCase()
                        }
                        value={type.toLocaleLowerCase()}
                      >
                        {type}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("pf_late_payment_penalty") === "yes" && (
            <div i2c-grid="6@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pf_late_payment_fee"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className={"single-input-field"}
                      placeholder="Enter Fee"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      invalid={errors.pf_late_payment_fee ? true : false}
                      size="large"
                      required
                      label="Specify late payment fee"
                      name={"pf_late_payment_fee"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pf_late_payment_fee &&
                    methods.formState.touchedFields.pf_late_payment_fee
                      ? true
                      : false
                  }
                  message={
                    errors.pf_late_payment_fee?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="pf_grace_period"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Do you wish to define a grace period for late payment?"
                    value={methods.watch("pf_grace_period")}
                    {...field}
                    name="pf_grace_period"
                    onI2cChange={(e) => {
                      if (e.target.value === "no") {
                        methods.setValue("pf_grace_period_days", "");
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No"].map((type, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("pf_grace_period") ===
                          type.toLocaleLowerCase()
                        }
                        value={type.toLocaleLowerCase()}
                      >
                        {type}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("pf_grace_period") === "yes" && (
            <div i2c-grid="6@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pf_grace_period_days"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className={"single-input-field"}
                      placeholder="Enter number of days"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      invalid={errors.pf_grace_period_days ? true : false}
                      size="large"
                      required
                      label="Specify garce period"
                      name={"pf_grace_period_days"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pf_grace_period_days &&
                    methods.formState.touchedFields.pf_grace_period_days
                      ? true
                      : false
                  }
                  message={
                    errors.pf_grace_period_days?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
        </div>
        <div className="section-space">
          <div className="sub-heading mb-16">Card Account Statements</div>
          <div className="single-field-wrapper">
            <Controller
              name="pf_card_account_statement"
              control={control}
              render={({ field }) => (
                <>
                  <I2cCheckboxGroup {...field}>
                    <div i2c-grid="grid gap-sm">
                      {cardAccountStatement.map((option, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={option.label}
                          className="cardlist-custom-direction"
                          sublabel=""
                          value=""
                          checked={methods
                            .watch("pf_card_account_statement")
                            .includes(option.value)}
                          onI2cCheckboxClicked={(e) => {
                            handleApplicableFeatureChanges(option.value);
                          }}
                          type="checkbox"
                        >
                          <I2cCheckbox
                            slot="prefix"
                            value={option.value}
                            label=""
                            filled
                            checked={methods
                              .watch("pf_card_account_statement")
                              .includes(option.value)}
                            className="customCheckbox"
                         
                          ></I2cCheckbox>
                          {option.tooltip !== "" && (
                            <I2cTooltip
                              slot="suffix"
                              hoist
                              content={option.tooltip}
                              placement="right-start"
                            >
                              <I2cIcon name="cs-linear-help-circle"></I2cIcon>
                            </I2cTooltip>
                          )}
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cCheckboxGroup>
                </>
              )}
            />
          </div>
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-16">Statement Generation Date</div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_statement_generation"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Do you want to specify the statement generation day of the month?"
                    value={methods.watch("pf_statement_generation")}
                    {...field}
                    name="pf_statement_generation"
                    onI2cChange={(e) => {
                      if (e.target.value === "no") {
                        methods.setValue("pf_statment_generation_date", "");
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No"].map((type, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("pf_statement_generation") ===
                          type.toLocaleLowerCase()
                        }
                        value={type.toLocaleLowerCase()}
                      >
                        {type}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("pf_statement_generation") === "yes" && (
            <div i2c-grid="12">
              <div className="custom-label-light mb-8">
                Statement will be generated on the:
              </div>
              <div className="single-field-wrapper">
                <Controller
                  name="pf_statment_generation_date"
                  control={control}
                  render={({ field }) => (
                    <I2cRadioGroup
                      value={methods.watch("pf_statment_generation_date")}
                      {...field}
                      name="pf_statment_generation_date"
                      onI2cChange={(e) => {
                        field.onChange(e);
                        methods.trigger();
                        handleValueChanges();
                      }}
                    >
                      <div i2c-grid="grid gap-sm">
                        {statementGeneratedOn.map((type, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="6@md"
                            className="cardlist-custom-direction"
                            variant="receipt"
                            label={type.label}
                            sublabel=" "
                            type="checkbox"
                            checked={
                              methods.watch("pf_statment_generation_date") ===
                              type.value
                            }
                          >
                            <I2cRadio
                              slot="prefix"
                              name="of_fisco"
                              filled
                              value={type.value}
                              label=""
                            ></I2cRadio>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cRadioGroup>
                  )}
                />
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">
              Credit Card Collection Details
            </div>
            <div className="custom-label-light mb-16">
              Do you want i2c Inc. to provide account details for collection
              services?
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_credit_card_collection_detail"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_credit_card_collection_detail")}
                    {...field}
                    name="pf_credit_card_collection_detail"
                    onI2cChange={(e) => {
                      if (e.target.value === "no") {
                        methods.setValue(
                          "pf_credit_card_collection_detail_provider",
                          "",
                        );
                        methods.setValue(
                          "pf_credit_card_collection_detail_provider_other",
                          "",
                        );
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No"].map((type, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("pf_credit_card_collection_detail") ===
                          type.toLocaleLowerCase()
                        }
                        value={type.toLocaleLowerCase()}
                      >
                        {type}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("pf_credit_card_collection_detail") === "yes" && (
            <div i2c-grid="12">
              <div className="custom-label-light mb-16">
                Please confirm who will i2c Inc. provide account details for
                closed accounts intended for collection services.
              </div>
              <div className="single-field-wrapper">
                <Controller
                  name="pf_credit_card_collection_detail_provider"
                  control={control}
                  render={({ field }) => (
                    <I2cRadioGroup
                      value={methods.watch(
                        "pf_credit_card_collection_detail_provider",
                      )}
                      {...field}
                      name="pf_credit_card_collection_detail_provider"
                      onI2cChange={(e) => {
                        if (e.target.value !== "other") {
                          methods.setValue(
                            "pf_credit_card_collection_detail_provider_other",
                            "",
                          );
                        }
                        field.onChange(e);
                        methods.trigger();
                        handleValueChanges();
                      }}
                    >
                      <div i2c-grid="grid gap-sm">
                        {[
                          {
                            label: "Program owner, specified above",
                            value: "program-owner",
                          },
                          { label: "Other", value: "other" },
                        ].map((type, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="6@md"
                            variant="receipt"
                            label={type.label}
                            checked={
                              methods.watch(
                                "pf_credit_card_collection_detail_provider",
                              ) === type.value
                            }
                            sublabel=" "
                            value=""
                            type="checkbox"
                          >
                            <I2cRadio
                              slot="prefix"
                              filled
                              name=""
                              value={type.value}
                              label=""
                            ></I2cRadio>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cRadioGroup>
                  )}
                />
              </div>
              {methods.watch("pf_credit_card_collection_detail_provider") ===
              "other" ? (
                <div className="single-field-wrapper">
                  <Controller
                    name="pf_credit_card_collection_detail_provider_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className={"halfWidth mt-16"}
                        placeholder="Please Specify"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        invalid={
                          errors.pf_credit_card_collection_detail_provider_other
                            ? true
                            : false
                        }
                        required
                        size="large"
                        label="Other Details"
                        name={"pf_credit_card_collection_detail_provider_other"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.pf_credit_card_collection_detail_provider_other &&
                      methods.formState.touchedFields
                        .pf_credit_card_collection_detail_provider_other
                        ? true
                        : false
                    }
                    message={
                      errors.pf_credit_card_collection_detail_provider_other
                        ?.message ?? "Invalid input"
                    }
                  /> */}
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">Credit Bureau Reporting</div>
            <div className="custom-label-light mb-16">
              Please confirm if you want to subscribe to i2c Inc. credit bureau
              reporting services.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_credit_bureau_report_required"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_credit_bureau_report_required")}
                    {...field}
                    name="pf_credit_bureau_report_required"
                    onI2cChange={(e) => {
                      if (e.target.value === "no") {
                        methods.setValue("pf_credit_reporting_bureaus", []);
                        methods.setValue(
                          "pf_credit_reporting_bureaus_other",
                          "",
                        );
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No"].map((type, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("pf_credit_bureau_report_required") ===
                          type.toLocaleLowerCase()
                        }
                        value={type.toLocaleLowerCase()}
                      >
                        {type}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("pf_credit_bureau_report_required") === "yes" && (
            <div i2c-grid="12">
              <div className="custom-label-light mb-8">
                Please specify the credit bureaus below:
              </div>
              <div className="single-field-wrapper">
                <Controller
                  name="pf_credit_reporting_bureaus"
                  control={control}
                  render={({ field }) => (
                    <>
                      <I2cCheckboxGroup {...field}>
                        <div i2c-grid="grid gap-sm">
                          {creditBreue.map((option, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="6@md"
                              variant="receipt"
                              label={option.label}
                              sublabel=""
                              value=""
                              checked={methods
                                .watch("pf_credit_reporting_bureaus")
                                .includes(option.value)}
                              onI2cCheckboxClicked={(e) => {
                                handleBureauChanges(option.value);
                              }}
                              type="checkbox"
                            >
                              <I2cCheckbox
                                slot="prefix"
                                value={option.value}
                                label=""
                                filled
                                checked={methods
                                  .watch("pf_credit_reporting_bureaus")
                                  .includes(option.value)}
                                className="customCheckbox"
                              
                              ></I2cCheckbox>
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cCheckboxGroup>
                      <ErrorMessage
                        show={
                          errors.pf_credit_reporting_bureaus &&
                          methods.formState.touchedFields
                            .pf_credit_reporting_bureaus
                            ? true
                            : false
                        }
                        message={
                          errors.pf_credit_reporting_bureaus?.message ??
                          "Invalid input"
                        }
                      />
                    </>
                  )}
                />
              </div>
            </div>
          )}
          {methods.watch("pf_credit_reporting_bureaus").includes(3) && (
            <div i2c-grid="6@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pf_credit_reporting_bureaus_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className={"single-input-field"}
                      placeholder="Please Specify"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      invalid={
                        errors.pf_credit_reporting_bureaus_other ? true : false
                      }
                      size="large"
                      required
                      label="Enter Details"
                      name={"pf_credit_reporting_bureaus_other"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pf_credit_reporting_bureaus_other &&
                    methods.formState.touchedFields
                      .pf_credit_reporting_bureaus_other
                      ? true
                      : false
                  }
                  message={
                    errors.pf_credit_reporting_bureaus_other?.message ??
                    "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
        </div>
        <div className="section-space">
          <div className="sub-heading mb-4">Card Usage Restrictions</div>
          <div className="custom-label-light mb-16">
            Do you want to limit where a card can be used?
          </div>
          <div className="single-field-wrapper">
            <Controller
              name="pf_card_usage_restriction"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  value={methods.watch("pf_card_usage_restriction")}
                  {...field}
                  name="pf_card_usage_restriction"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((type, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("pf_card_usage_restriction") ===
                        type.toLocaleLowerCase()
                      }
                      value={type.toLocaleLowerCase()}
                    >
                      {type}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
          </div>
        </div>
        <div className="section-space">
          <div className="sub-heading mb-4">Cash Advance Limits</div>
          <div className="custom-label-light mb-16">
            Do you want to limit where a card can be used?
          </div>
          <div className="single-field-wrapper">
            <Controller
              name="pf_cash_advance_limit"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  value={methods.watch("pf_cash_advance_limit")}
                  {...field}
                  name="pf_cash_advance_limit"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((type, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("pf_cash_advance_limit") ===
                        type.toLocaleLowerCase()
                      }
                      value={type.toLocaleLowerCase()}
                    >
                      {type}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
          </div>
        </div>

        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="organize-tooltip mb-4">
              <div className="sub-heading">Cardholder Notifications</div>
              <I2cTooltip
                content="Managed by the i2c Inc. platform, based upon client notification content and scheduling parameters with notifications being sent directly to Cardholders.
                            Managed by the client outside of the i2c Inc. platform. Data in this case can be shared through SMPP Setup/Push Alerts."
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </div>
            <div className="custom-label-light mb-16">
              Will the card account activity related notifications be sent to
              cardholders or program managers?
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_cardholder_notification"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_cardholder_notification")}
                    {...field}
                    name="pf_cardholder_notification"
                    onI2cChange={(e) => {
                      methods.setValue(
                        "pf_cardholder_notification_channels",
                        "",
                      );
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {cardholderNotification.map((type, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={type.label}
                          checked={
                            methods.watch("pf_cardholder_notification") ===
                            type.value
                          }
                          sublabel=" "
                          value=""
                          type="checkbox"
                        >
                          <I2cRadio
                            slot="prefix"
                            filled
                            name=""
                            value={type.value}
                            label=""
                          ></I2cRadio>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("pf_cardholder_notification").length > 0 ? (
            <div i2c-grid="12">
              <div className="custom-label-light mb-8">
                Please select the channel through which alerts will be shared:
              </div>
              <div className="single-field-wrapper">
                <Controller
                  name="pf_cardholder_notification_channels"
                  control={control}
                  render={({ field }) => (
                    <I2cRadioGroup
                      value={methods.watch(
                        "pf_cardholder_notification_channels",
                      )}
                      {...field}
                      name="pf_cardholder_notification_channels"
                      onI2cChange={(e) => {
                        field.onChange(e);
                        methods.trigger();
                        handleValueChanges();
                      }}
                    >
                      {(methods.watch("pf_cardholder_notification") ===
                      "send-alert-to-cardholder"
                        ? [
                            { label: "SMS", value: "sms" },
                            { label: "Email", value: "email" },
                            { label: "Push", value: "push" },
                          ]
                        : [
                            { label: "Push", value: "push" },
                            { label: "SMPP", value: "smpp" },
                          ]
                      ).map((type, index) => (
                        <I2cRadioButton
                          key={index}
                          checked={
                            methods.watch(
                              "pf_cardholder_notification_channels",
                            ) === type.value
                          }
                          value={type.value}
                        >
                          {type.label}
                        </I2cRadioButton>
                      ))}
                    </I2cRadioGroup>
                  )}
                />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <div className="sub-heading mb-16">Customer Support</div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_customer_support_channels"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Which customer support channels will be available for cardholders:"
                    value={methods.watch("pf_customer_support_channels")}
                    {...field}
                    name="pf_customer_support_channels"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {customerSupportChannels.map((type, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={type.label}
                          checked={
                            methods.watch("pf_customer_support_channels") ===
                            type.value
                          }
                          sublabel=" "
                          value=""
                          type="checkbox"
                        >
                          <I2cRadio
                            slot="prefix"
                            filled
                            name=""
                            value={type.value}
                            label=""
                          ></I2cRadio>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="pf_customer_support_who_will_provide"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Who will provide customer support?"
                    value={methods.watch(
                      "pf_customer_support_who_will_provide",
                    )}
                    {...field}
                    name="pf_customer_support_who_will_provide"
                    onI2cChange={(e) => {
                      if (e.target.value !== "client-third-party") {
                        [
                          "pf_customer_support_provider_other_company",
                          "pf_customer_support_provider_other_contact_name",
                          "pf_customer_support_provider_other_title",
                          "pf_customer_support_provider_other_phone",
                          "pf_customer_support_provider_other_phone_country",
                          "pf_customer_support_provider_other_email",
                        ].forEach((field) => methods.setValue(field, ""));
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {customerSupportProvider.map((type, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={type.label}
                          checked={
                            methods.watch(
                              "pf_customer_support_who_will_provide",
                            ) === type.value
                          }
                          sublabel=" "
                          value=""
                          type="checkbox"
                        >
                          <I2cRadio
                            slot="prefix"
                            filled
                            name=""
                            value={type.value}
                            label=""
                          ></I2cRadio>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("pf_customer_support_who_will_provide") ===
            "client-third-party" && (
            <div i2c-grid="12">
              <div className="custom-label-light mb-12">
                If using a 3rd Party Vendor, please provide details:
              </div>
              <div i2c-grid="grid gap-column-sm gap-row-md">
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_customer_support_provider_other_company"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          placeholder="Enter Name"
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            methods.trigger();
                            handleValueChanges();
                          }}
                          size="large"
                          label="Company Name"
                          name={"pf_customer_support_provider_other_company"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_customer_support_provider_other_company &&
                        methods.formState.touchedFields
                          .pf_customer_support_provider_other_company
                          ? true
                          : false
                      }
                      message={
                        errors.pf_customer_support_provider_other_company
                          ?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_customer_support_provider_other_contact_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          placeholder="Enter Name"
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            methods.trigger();
                            handleValueChanges();
                          }}
                          size="large"
                          label="Contact Name"
                          name={
                            "pf_customer_support_provider_other_contact_name"
                          }
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_customer_support_provider_other_contact_name &&
                        methods.formState.touchedFields
                          .pf_customer_support_provider_other_contact_name
                          ? true
                          : false
                      }
                      message={
                        errors.pf_customer_support_provider_other_contact_name
                          ?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_customer_support_provider_other_title"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          placeholder="Enter Title"
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            methods.trigger();
                            handleValueChanges();
                          }}
                          size="large"
                          label="Job Title"
                          name={"pf_customer_support_provider_other_title"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_customer_support_provider_other_title &&
                        methods.formState.touchedFields
                          .pf_customer_support_provider_other_title
                          ? true
                          : false
                      }
                      message={
                        errors.pf_customer_support_provider_other_title
                          ?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <I2cPhoneField
                      format="INTERNATIONAL"
                      label="Cell Number"
                      helpIcon=""
                      name="pf_customer_support_provider_other_phone"
                      size="large"
                      required
                      country-box
                      selectedCountry={methods.watch(
                        "pf_customer_support_provider_other_phone_country",
                      ) || "US"}
                      errorMessageVisible={false}
                      onI2cChange={(e) => {
                        const country = e.target.country;
                        const isValid = e.target.isValid;
                        const value = e.target.value;
                        methods.setValue(
                          "pf_customer_support_provider_other_phone_country",
                          country,
                        );
                        methods.setValue(
                          "pf_customer_support_provider_other_phone",
                          value,
                        );
                        if (!isValid) {
                          methods.setError(
                            "pf_customer_support_provider_other_phone",
                            {
                              message: e.target.guide,
                            },
                          );
                        } else {
                          methods.clearErrors(
                            "pf_customer_support_provider_other_phone",
                          );
                        }
                        methods.trigger();
                        handleValueChanges();
                      }}
                      value={
                        methods.watch(
                          "pf_customer_support_provider_other_phone",
                        ) ?? ""
                      }
                    />
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_customer_support_provider_other_email"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          placeholder="Enter Email"
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            methods.trigger();
                            handleValueChanges();
                          }}
                          size="large"
                          label="Email"
                          type="email"
                          name={"pf_customer_support_provider_other_email"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_customer_support_provider_other_email &&
                        methods.formState.touchedFields
                          .pf_customer_support_provider_other_email
                          ? true
                          : false
                      }
                      message={
                        errors.pf_customer_support_provider_other_email
                          ?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default PaymentCard;
